module.exports = __webpack_public_path__ + "img/image96.c708da83.jpg";